import { createSlice } from '@reduxjs/toolkit';

import { assignDefinedFields } from '@polyai/stream/store/utils/assign-fields';
import { assignMetadata } from '@polyai/stream/store/utils/assign-metadata';

import { updatePersonality } from '../actions';
import { personalityReferencesAdapter } from '../adapters';
import { PERSONALITY_INITIAL_STATE } from '../constants';

const slice = createSlice({
  name: 'personality',
  initialState: PERSONALITY_INITIAL_STATE,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(updatePersonality, (state, action) => {
      if (action.payload.adjectives?.values?.Other) {
        Object.keys(state.adjectives).forEach(key => {
          state.adjectives[key] = false;
        });
      } else if (state.adjectives.Other) {
        state.adjectives.Other = false;
      }

      if (action.payload.adjectives) {
        assignDefinedFields(
          state.adjectives,
          action.payload.adjectives?.values ?? {},
        );
      }

      if (action.payload.custom) {
        state.custom = action.payload.custom ?? '';
      }
      if (action.payload.references) {
        state.references = personalityReferencesAdapter.createInitialState(
          action.payload.references,
        );
      }
      assignMetadata(action, state);
    });
  },
});

export default slice.reducer;
